import { z } from "zod";

const reportSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.union([z.string(), z.number()]).optional(),
});

export const profileReportSchema = z.object({
  report: reportSchema.nullable().refine(Boolean, "Selecione um relatório"),
});

export type TProfileReportForm = z.infer<typeof profileReportSchema>;
